import { useAtomValue } from 'jotai';
import { ReactNode } from 'react';
import {
  unwrappedNavigationCompetitionIdAtom,
  unwrappedNavigationGameIdAtom,
  unwrappedNavigationKeeperIdAtom,
  unwrappedNavigationPlayerIdAtom,
  unwrappedNavigationTeamIdAtom,
} from '@/atoms/navigation';

// AppShell can't mount (and so can't fire its navigation-data queries) until
// HandleInvalidEntityUser's licence check resolves, even though that data has no
// dependency on the licence check. Reading the unwrapped navigation atoms here — from
// a provider that sits above HandleInvalidEntityUser — starts those queries as soon as
// we're authenticated, so they run concurrently with the licence check instead of only
// starting once it clears. The unwrapped atoms never suspend, so this can't block
// rendering of children.
export const PrefetchNavigationData = ({ children }: { children: ReactNode }) => {
  useAtomValue(unwrappedNavigationTeamIdAtom);
  useAtomValue(unwrappedNavigationPlayerIdAtom);
  useAtomValue(unwrappedNavigationGameIdAtom);
  useAtomValue(unwrappedNavigationCompetitionIdAtom);
  useAtomValue(unwrappedNavigationKeeperIdAtom);
  return children;
};
